export default function (state, val) {
    state.page = 1;
    state.loading = false;
    val.Items.forEach(i => {
        i.value = i.RegularPaymentId;
        i.label = i.RegularPaymentName;
        i.CreatorOptions = [{label: '', value: ''}, val.user];
        i.BookkeeperOptions = [{label: '', value: ''}, val.user];
        i.PaymasterOptions = [{label: '', value: ''}, val.user];

        if (i.CreatorId&&i.CreatorId!==val.user.value) i.CreatorOptions.push({
            value: i.CreatorId,
            label: i.CreatorUser
        });
        if (i.BookkeeperId&&i.BookkeeperId!==val.user.value) i.BookkeeperOptions.push({
            value: i.BookkeeperId,
            label: i.BookkeeperUser
        });
        if (i.PaymasterId&&i.PaymasterId!==val.user.value) i.PaymasterOptions.push({
            value: i.PaymasterId,
            label: i.PaymasterUser
        });

    });
    state.items = val.Items;
}